import React from 'react'

const Help = () => {
  return (
    <div>Help & Support</div>
  )
}

export default Help